module.exports = __webpack_public_path__ + "static/media/eye-solid.4e6d1bba.svg";